import requester from '@/lib/axios';
import { EnrollmentStatusEnum } from '@/models/Enrollment';
import { KlassStatusEnum } from '@/models/Klass';
import {
  PresenceEnum,
  ScheduledLessonReportEnum,
} from '@/models/ScheduledLessonReport';
import { BaseFilters } from '@/models/Service';
import { StudentHistory } from '@/models/StudentHistory';

export interface ListStudentHistoryFilters extends BaseFilters {
  courseId?: number;
  coursePathSlug?: string;
  courseLineId?: number[];
  enrollmentStatus?: EnrollmentStatusEnum[];
  klassId?: number;
  status?: KlassStatusEnum[];
  presence?: PresenceEnum[];
  ordering?: string;
  reportStatus?: ScheduledLessonReportEnum[];
  dateRangeAfter?: string;
  dateRangeBefore?: string;
}

export const getStudentHistory = async (
  studentId: number,
  params?: ListStudentHistoryFilters,
) => {
  const { data } = await requester().get<StudentHistory>(
    `students/${studentId}/history/`,
    {
      params,
    },
  );
  return data;
};
